// /api/user/me

import {AxiosResponse} from 'axios';
import req from '@/api/utilities/axios';
import {User} from '@/User';

export const getLoggedInUser = (): Promise<User> => req.get(`user/me`).then(r => r.data.data);
